/* global femcare */

femcare.navigation.navigationMain = {
    $menuModal: $('.modal--navigation'),
    $submenuToggleButtons: $('.navigation-bar__topic[aria-haspopup]'),
    openMenuButton: document.querySelector('.navigation-bar__icon--open'),
    closeMenuButton: document.querySelector('.navigation-bar__icon--close'),
    logoWrapper: document.querySelector('.navigation-bar__logo-wrapper'),
    mobileLogoTarget: document.querySelector('.mobile-navigation__logo-target'),
    logoOriginalParent: null,
    logoOriginalNextSibling: null,
    hasMovedLogo: false,
    animatedLogoClone: null,
    animatedLogoTemplate: null,
    animatedLogoTemplateSource: null,
    mobileLogoAnimationDuration: 450,
    mobileLogoAnimationTimeout: null,

    /**
     * Initialize all navigation behaviors.
     */
    init() {
        if ($('.navigation').length) {
            this.setupDesktopNavigation();
            this.setupLanguageMenu();
            this.adjustSampleItemText();
            if (this.openMenuButton && this.closeMenuButton) {
                this.storeLogoOrigin();
                this.prepareAnimatedLogoTemplate();
                this.openMobileMenu();
                this.closeMobileMenu();
            }
        }
    },

    /**
     * Setup desktop navigation: sticky header + submenu hover/click.
     */
    setupDesktopNavigation() {
        this.$submenuToggleButtons.on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            const $toggle = $(e.currentTarget);
            if ($toggle.hasClass('open')) {
                this.closeNavigationDropdown();
            } else {
                this.openNavigationDropdown($toggle);
            }
        });

        this.$submenuToggleButtons
            .parent()
            .on('mouseenter', e => {
                const $toggle = $(e.currentTarget).find('.navigation-bar__topic[aria-haspopup]');
                this.openNavigationDropdown($toggle);
            })
            .on('mouseleave', () => {
                this.closeNavigationDropdown();
            });

        // Bind the Escape key to close any open navigation dropdown.
        $(document).on('keydown.navigationMain', e => {
            if (e.key === 'Escape') {
                this.closeNavigationDropdown();
            }
        });
    },

    /**
     * Setup language popout toggle and click-outside-to-close behavior.
     */
    setupLanguageMenu() {
        const $languageContainer = $('.navigation-bar__language');
        const $toggle = $('.navigation-bar__language-toggle');
        const $popout = $('.navigation-bar__language-popout');

        $toggle.on('click', (e) => {
            e.preventDefault();
            const isOpen = $popout.is(':visible');

            if (isOpen) {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
            } else {
                this.openLanguagePopout($languageContainer, $popout, $toggle);
            }
        });
    },

    /**
     * Open the language popout and setup close handlers.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    openLanguagePopout($languageContainer, $popout, $toggle) {
        $languageContainer.addClass('displayed');
        $popout.addClass('displayed');
        $toggle.attr('aria-expanded', 'true');

        // Close on Escape
        $(document).on('keydown.languagePopout', (e) => {
            if (e.key === 'Escape') {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
                $toggle.trigger('focus');
            }
        });

        // Close when focus moves outside
        setTimeout(() => {
            $popout.find('button, a, [tabindex]').on('blur', () => {
                this.handleLanguagePopoutBlur($languageContainer, $popout, $toggle);
            });
        }, 0);
    },

    /**
     * Close the language popout and remove event handlers.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    closeLanguagePopout($languageContainer, $popout, $toggle) {
        $languageContainer.removeClass('displayed');
        $popout.removeClass('displayed');
        $toggle.attr('aria-expanded', 'false');
        $(document).off('keydown.languagePopout');
    },

    /**
     * Handle blur event for language popout to close when focus leaves.
     * @param {jQuery} $languageContainer The language container element
     * @param {jQuery} $popout The popout element
     * @param {jQuery} $toggle The toggle button
     */
    handleLanguagePopoutBlur($languageContainer, $popout, $toggle) {
        setTimeout(() => {
            if (
                !$.contains($popout[0], document.activeElement) &&
                document.activeElement !== $toggle[0]
            ) {
                this.closeLanguagePopout($languageContainer, $popout, $toggle);
            }
        }, 10);
    },

    /**
     * Open the main navigation and bind blur handlers to close when focus leaves.
     * @param {jQuery} $toggle The submenu toggle that triggered open
     */
    openNavigationDropdown($toggle) {
        $('.navigation').addClass('open');
        this.showSubmenu($toggle);

        this.$submenuToggleButtons.parent().each((_, parent) => {
            const $parent = $(parent);
            $parent.find('a').on('blur', () => {
                setTimeout(() => {
                    if (!$.contains(parent, document.activeElement)) {
                        this.closeNavigationDropdown();
                    }
                }, 10);
            });
        });
    },

    /**
     * Close the main navigation and unbind all related event handlers.
     */
    closeNavigationDropdown() {
        $('.navigation').removeClass('open');
        this.hideSubmenu();
        $('html').off('click');
        this.$submenuToggleButtons.parent().find('a').off('blur');
    },

    /**
     * Show the given submenu toggle's submenu.
     * @param {jQuery} $toggle The submenu toggle to open
     */
    showSubmenu($toggle) {
        this.hideSubmenu();
        $toggle
            .addClass('open')
            .attr('aria-expanded', true);
        $toggle.parent()
            .find('.navigation-bar__submenu')
            .stop(true, true)
            .show()
            .addClass('open');
    },

    /** Hide any open submenu. */
    hideSubmenu() {
        this.$submenuToggleButtons
            .removeClass('open')
            .attr('aria-expanded', false);
        $('.navigation-bar .navigation-bar__submenu')
            .hide()
            .removeClass('open');
    },

    /** Show the mobile menu open button and hide the close button. */
    openMobileMenu() {
        this.openMenuButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.openNavigationModal();
        });
    },

    /** Hide the mobile menu and toggle open/close buttons. */
    closeMobileMenu() {
        this.closeMenuButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.closeNavigationModal();
        });
    },

    /** Cache the logo's original DOM position for later restoration. */
    storeLogoOrigin() {
        if (!this.logoWrapper || this.logoOriginalParent) {
            return;
        }

        this.logoOriginalParent = this.logoWrapper.parentNode;
        this.logoOriginalNextSibling = this.logoWrapper.nextSibling;
    },

    /**
     * Return the navigation modal element.
     * @returns {HTMLElement | undefined}
     */
    getMenuModalElement() {
        return this.$menuModal[0];
    },

    /**
     * Open the navigation modal using height animation instead of generic displayed state.
     */
    openNavigationModal() {
        const menuModalElement = this.getMenuModalElement();
        if (!menuModalElement || menuModalElement.classList.contains('modal--navigation-open')) {
            return;
        }

        femcare.modal.closeAllOpenModals();
        femcare.modal.lastOpenedTrigger = this.openMenuButton;

        this.toggleMobileMenuButtons(true);
        menuModalElement.classList.add('modal--navigation-open');
        menuModalElement.setAttribute('aria-hidden', 'false');

        this.moveLogoToMobileMenu();
        femcare.modal.trapFocus(menuModalElement);
    },

    /**
     * Close the navigation modal height animation and restore logo/navbar state.
     * @param {boolean} returnFocus Whether to restore focus to the opening trigger
     */
    closeNavigationModal(returnFocus = true) {
        const menuModalElement = this.getMenuModalElement();
        if (!menuModalElement || !menuModalElement.classList.contains('modal--navigation-open')) {
            return;
        }

        menuModalElement.classList.remove('modal--navigation-open');
        menuModalElement.setAttribute('aria-hidden', 'true');
        this.toggleMobileMenuButtons(false);
        this.restoreLogoToNavigationBar();
        this.releaseMobileMenuFocusTrap(menuModalElement);

        if (returnFocus && femcare.modal.lastOpenedTrigger) {
            femcare.modal.lastOpenedTrigger.focus();
            femcare.modal.lastOpenedTrigger = null;
        }
    },

    /** Remove the generic modal focus trap from the navigation modal. */
    releaseMobileMenuFocusTrap(menuModalElement) {
        if (!menuModalElement?._trapFocusHandler) {
            return;
        }

        menuModalElement.removeEventListener('keydown', menuModalElement._trapFocusHandler);
        delete menuModalElement._trapFocusHandler;
    },

    /** Move the current navigation logo into the mobile navigation modal. */
    moveLogoToMobileMenu() {
        if (!this.logoWrapper || !this.mobileLogoTarget || this.hasMovedLogo) {
            return;
        }

        this.transitionLogo(() => {
            this.mobileLogoTarget.appendChild(this.logoWrapper);
            this.logoWrapper.classList.add('navigation-bar__logo-wrapper--in-modal');
        }, true);
    },

    /** Restore the navigation logo to its original position in the navbar. */
    restoreLogoToNavigationBar() {
        if (!this.logoWrapper || !this.logoOriginalParent) {
            return;
        }

        if (!this.hasMovedLogo) {
            return;
        }

        this.transitionLogo(() => {
            if (this.logoOriginalNextSibling && this.logoOriginalNextSibling.parentNode === this.logoOriginalParent) {
                this.logoOriginalParent.insertBefore(this.logoWrapper, this.logoOriginalNextSibling);
            } else {
                this.logoOriginalParent.appendChild(this.logoWrapper);
            }

            this.logoWrapper.classList.remove('navigation-bar__logo-wrapper--in-modal');
        }, false);
    },

    /**
     * Animate the real logo between navbar and modal positions.
     * @param {Function} moveLogo A DOM move callback
     * @param {boolean} nextMovedState Whether the logo should be considered moved after animation
     */
    transitionLogo(moveLogo, nextMovedState) {
        this.cancelLogoAnimation();

        const currentLogoElement = this.getRenderedLogoElement(this.logoWrapper);
        const startRect = currentLogoElement?.getBoundingClientRect();
        const animatedLogoClone = this.createAnimatedLogoClone(currentLogoElement, startRect);
        this.setLogoVisibility(false);
        moveLogo();

        const movedLogoElement = this.getRenderedLogoElement(this.logoWrapper);
        const endRect = movedLogoElement?.getBoundingClientRect();

        this.animateLogoClone(animatedLogoClone, startRect, endRect, nextMovedState);
    },

    /** Warm the animated logo template outside the interaction path. */
    prepareAnimatedLogoTemplate() {
        const prepare = () => {
            const logoElement = this.getRenderedLogoElement(this.logoWrapper);
            if (logoElement) {
                this.getAnimatedLogoTemplate(logoElement);
            }
        };

        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(prepare, { timeout: 250 });
            return;
        }

        window.setTimeout(prepare, 0);
    },

    /** Clear any in-flight logo animation and reveal the real logo. */
    cancelLogoAnimation() {
        if (this.mobileLogoAnimationTimeout) {
            window.clearTimeout(this.mobileLogoAnimationTimeout);
            this.mobileLogoAnimationTimeout = null;
        }

        if (this.animatedLogoClone) {
            this.animatedLogoClone.remove();
            this.animatedLogoClone = null;
        }

        this.setLogoVisibility(true);
    },

    /**
     * Toggle the mobile navigation open/close buttons.
     * @param {boolean} isOpen Whether the navigation modal is open
     */
    toggleMobileMenuButtons(isOpen) {
        this.openMenuButton.classList.toggle('hidden', isOpen);
        this.closeMenuButton.classList.toggle('hidden', !isOpen);
    },

    /**
     * Show or hide the real logo wrapper during clone animation.
     * @param {boolean} isVisible Whether the real logo should be visible
     */
    setLogoVisibility(isVisible) {
        if (!this.logoWrapper) {
            return;
        }

        this.logoWrapper.classList.toggle('visible', isVisible);
        this.logoWrapper.classList.toggle('invisible', !isVisible);
    },

    /**
     * Return a rewritten clone template that can be reused for animation.
     * @param {Element | null} logoElement The currently rendered logo element
     * @returns {HTMLElement | null}
     */
    getAnimatedLogoTemplate(logoElement) {
        if (!logoElement) {
            return null;
        }

        if (this.animatedLogoTemplate && this.animatedLogoTemplateSource === logoElement) {
            return this.animatedLogoTemplate;
        }

        const logoTemplate = logoElement.cloneNode(true);
        if (!(logoTemplate instanceof HTMLElement) && !(logoTemplate instanceof SVGElement)) {
            return null;
        }

        this.rewriteSvgCloneIds(logoTemplate);
        this.animatedLogoTemplate = logoTemplate;
        this.animatedLogoTemplateSource = logoElement;

        return this.animatedLogoTemplate;
    },

    /**
     * Create a temporary visible logo clone for mobile open animation.
     * @param {Element | null} logoElement The currently rendered logo element
     * @param {DOMRect | undefined} startRect The current navbar logo position
     * @returns {HTMLElement | SVGElement | null}
     */
    createAnimatedLogoClone(logoElement, startRect) {
        const logoTemplate = this.getAnimatedLogoTemplate(logoElement);

        if (!logoTemplate || !startRect) {
            return null;
        }

        const logoClone = logoTemplate.cloneNode(true);
        logoClone.classList.add('navigation__logo--animating');
        logoClone.style.position = 'fixed';
        logoClone.style.top = `${startRect.top}px`;
        logoClone.style.left = `${startRect.left}px`;
        logoClone.style.width = `${startRect.width}px`;
        logoClone.style.height = `${startRect.height}px`;
        logoClone.style.margin = '0';
        logoClone.style.transform = 'none';
        logoClone.style.transition = `transform ${this.mobileLogoAnimationDuration}ms ease`;
        logoClone.style.pointerEvents = 'none';
        logoClone.style.zIndex = '9999';
        logoClone.style.overflow = 'visible';
        logoClone.style.maxWidth = 'none';
        logoClone.style.maxHeight = 'none';
        logoClone.style.transformOrigin = 'center top';

        document.body.appendChild(logoClone);
        this.animatedLogoClone = logoClone;

        return logoClone;
    },

    /**
     * Rewrite internal SVG ids and references so cloned logos keep their own clipPaths/gradients.
     * @param {HTMLElement | SVGElement} logoClone The animated logo clone
     */
    rewriteSvgCloneIds(logoClone) {
        if (!(logoClone instanceof SVGElement)) {
            return;
        }

        const idMap = new Map();
        const uniquePrefix = `animatedLogo${Date.now()}${Math.floor(Math.random() * 1000)}`;
        const elementsWithIds = logoClone.querySelectorAll('[id]');

        elementsWithIds.forEach((element, index) => {
            const oldId = element.id;
            const newId = `${uniquePrefix}-${index}`;

            idMap.set(oldId, newId);
            element.id = newId;
        });

        const attributesToRewrite = [
            'fill',
            'stroke',
            'filter',
            'mask',
            'clip-path',
            'xlink:href',
            'href'
        ];

        logoClone.querySelectorAll('*').forEach((element) => {
            attributesToRewrite.forEach((attributeName) => {
                const attributeValue = element.getAttribute(attributeName);

                if (!attributeValue) {
                    return;
                }

                let nextValue = attributeValue;

                idMap.forEach((newId, oldId) => {
                    nextValue = nextValue.replace(`url(#${oldId})`, `url(#${newId})`);
                    nextValue = nextValue.replace(`#${oldId}`, `#${newId}`);
                });

                if (nextValue !== attributeValue) {
                    element.setAttribute(attributeName, nextValue);
                }
            });
        });
    },

    /**
     * Animate the visible logo clone between two positions and reveal the real logo after travel.
     * @param {HTMLElement | SVGElement | null} animatedLogoClone The temporary animated clone
     * @param {DOMRect | undefined} startRect The rect before moving the logo
     * @param {DOMRect | undefined} endRect The rect after moving the logo
     * @param {boolean} nextMovedState Whether the real logo ends in modal or navbar
     */
    animateLogoClone(animatedLogoClone, startRect, endRect, nextMovedState) {
        if (!startRect || !endRect) {
            this.setLogoVisibility(true);
            this.hasMovedLogo = nextMovedState;
            return;
        }

        const deltaY = endRect.top - startRect.top;
        const scaleRatio = endRect.width / startRect.width;

        if (!animatedLogoClone) {
            this.setLogoVisibility(true);
            this.hasMovedLogo = nextMovedState;
            return;
        }

        requestAnimationFrame(() => {
            animatedLogoClone.style.transform = `translateY(${deltaY}px) scale(${scaleRatio})`;
        });

        this.mobileLogoAnimationTimeout = window.setTimeout(() => {
            animatedLogoClone.remove();
            this.animatedLogoClone = null;
            this.mobileLogoAnimationTimeout = null;
            this.setLogoVisibility(true);
            this.hasMovedLogo = nextMovedState;
        }, this.mobileLogoAnimationDuration);
    },

    /**
     * Return the currently rendered logo node regardless of future SVG variant.
     * @param {HTMLElement} logoWrapper The logo wrapper element
     * @returns {Element | null}
     */
    getRenderedLogoElement(logoWrapper) {
        if (!logoWrapper) {
            return null;
        }

        const logoSelector = [
            'svg',
            'img',
            'picture img',
            '.navigation__v-logo',
            '.navigation__ribbon-logo',
            '.navigation__rhombus-logo'
        ].join(', ');

        return logoWrapper.querySelector(logoSelector);
    },

    /**
     * Adjust the sample icon/label sizes based on rendered width
     * to add "large-text" modifiers when needed.
     */
    adjustSampleItemText() {
        const $iconsContainer = $('.navigation-bar__half--first .navigation-bar__icons');
        const $label = $iconsContainer.find('.navigation-bar__icon--primary span');
        const $sampleIcon = $('.navigation .navigation-bar__topic .icon-sample');
        if ($sampleIcon.length) {
            const $topic = $sampleIcon.closest('.navigation-bar__topic');
            const width = $topic.width();
            if (width > 98 || width === 0) {
                $topic.addClass('navigation-bar__topic--large-text');
            }
        }
        if ($label.length) {
            const labelWidth = $label.width();
            if (labelWidth > 108 || labelWidth === 0) {
                $iconsContainer.addClass('navigation-bar__icons--large-text');
            }
        }
    }
};
